export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`/sw.js?v=${encodeURIComponent(__APP_VERSION__ + '-' + __COMMIT_HASH__)}`)
        .catch((err) =>
          console.warn('[SW] registration failed (non-fatal for dev):', err)
        );
    });
  }
}
